import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import ApproachSection from './components/ApproachSection';
import WhyChooseSection from './components/WhyChooseSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <ApproachSection />
        <WhyChooseSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;